import React from 'react';
export function ProblemSection() {
  const painPoints = ['Ansiedad constante', 'Falta de claridad', 'Autosabotaje', 'Bloqueos económicos', 'Relaciones repetitivas', 'Miedo al cambio', 'Sensación de estancamiento', 'Frustración acumulada'];
  return <section className="px-4 py-7 sm:py-9 border-t border-brand-gold/10" data-id="element-177">
      <div className="max-w-5xl mx-auto" data-id="element-178">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-3 leading-tight" data-id="element-179">
          ¿Por qué tu realidad sigue igual aunque lo intentás todo?
        </h2>

        <p className="text-center text-sm sm:text-base text-brand-gray max-w-2xl mx-auto mb-5" data-id="element-180">
          Trabajás. Intentás. Visualizás. Te esforzás. Leés. Aprendés. Pero
          seguís sintiendo...
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3" data-id="element-181">
          {painPoints.map((point, i) => <div key={i} className="bg-dark-card border border-brand-gold/20 rounded-lg p-3 sm:p-3.5 hover:border-brand-gold/50 transition-colors" data-id="element-182">
              <div className="flex items-start gap-2" data-id="element-183">
                <span className="text-brand-gold text-sm" data-id="element-184">•</span>
                <span className="text-xs sm:text-sm" data-id="element-185">{point}</span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}